import { paSlice } from './pa.slice.ts';

export const { setPADataSet } = paSlice.actions;
